'use client';

import { useEffect } from 'react';
import { useIsOffline } from '@frameio/shared/hooks';
import { AlertBanner, useGlobalErrorContext } from '@frameio/vapor';
import { BannerWrapper } from './BannerWrapper';
import TEXT from './generated/TEXT/NetworkStatusBanner';

TEXT.DEFINE({
  /** Title shown when user loses internet connection */
  offlineBannerTitle: "Looks like you're offline",
});

export function NetworkStatusBanner() {
  const { hasGlobalErrorState, setHasGlobalErrorState } =
    useGlobalErrorContext();

  // @todo (WEB-677): re-evaluate this approach vs. sockets for offline detection
  // when sockets are further along.
  const navigatorIsOffline = useIsOffline();

  useEffect(() => {
    if (hasGlobalErrorState && !navigatorIsOffline) {
      setHasGlobalErrorState(false);
    } else if (!hasGlobalErrorState && navigatorIsOffline) {
      setHasGlobalErrorState(true);
    }
  }, [hasGlobalErrorState, navigatorIsOffline, setHasGlobalErrorState]);

  if (!navigatorIsOffline) {
    return null;
  }

  return (
    <BannerWrapper>
      <AlertBanner
        data-testid="offline-banner"
        title={TEXT.offlineBannerTitle}
        variant="error"
      />
    </BannerWrapper>
  );
}
